import ProxyBase from '../../../../../../core/proxies/ProxyBase'

class ReportProxy extends ProxyBase {
  addToCart(params) {
    return this.post('CartItems', params)
  }
  getLastPurchaseDate(params) {
    return this.post('Orders/LastPurchaseDate', params)
  }
}

const proxy = new ReportProxy('CartAndOrder/')
export default proxy
